import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash-es/get';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Box, Button, LinkText, Heading } from '@components/common';
import { MobileContainer } from '@containers/layout';
import SelectorButton from '@components/SelectorButton';
import MoveOutModal from '@containers/account/MoveOutModal';
import HSvsDCModal from './HSvsDCModal';
import BookingActions, { BookingSelectors } from '@redux/BookingRedux';
import { AppSelectors } from '@redux/AppRedux';
import { SERVICE_TYPES } from '@services/minte';
import { stripePriceConverter } from '@services/transform';

const ButtonWrapper = styled(SelectorButton)`
  width: 164px;
  height: 164px;
`;

const MobileFlexWrapper = styled(Box)`
  @media screen and (max-width: 767px) {
    flex: 1;
  }
`;

function ServiceTypeSingle(props) {
  const {
    selectedServiceType,
    serviceTypeData,
    setServiceType,
    initMoveOutBooking,
    propertyInfo,
    onSubmit
  } = props;
  const [show, toggleModal] = useState(false);
  const [showMoveOut, toggleMoveOutModal] = useState(false);

  const handleBookMoveOut = () => {
    initMoveOutBooking(false);
  };

  const serviceTypeGroups = [
    [SERVICE_TYPES.HOTEL_STYLE, SERVICE_TYPES.DEEP_CLEAN]
  ];

  return (
    <MobileContainer>
      <MobileFlexWrapper
        display="flex"
        width={1}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Heading px={2} mb={4}>
          Which level of service would you like?
        </Heading>
        {serviceTypeGroups.map(group => {
          if (!group || !group.length) {
            return null;
          }
          const key = `service_type_group_${group[0]}`;
          return (
            <Box key={key} px={2} mb={4} display="flex" flexDirection="row">
              {group.map((serviceType, index) => {
                const data = serviceTypeData[serviceType];
                const { title, icon } = data;

                const price = get(
                  propertyInfo,
                  `serviceTypes.${serviceType}`,
                  0
                );
                return (
                  <ButtonWrapper
                    key={serviceType}
                    selected={serviceType === selectedServiceType}
                    title={title}
                    subtitle={`$${stripePriceConverter(price)}`}
                    icon={icon}
                    onClick={() => {
                      setServiceType(serviceType);
                      onSubmit();
                    }}
                    mr={index === 0 ? 2 : undefined}
                  />
                );
              })}
            </Box>
          );
        })}
        <Button
          onClick={() => toggleModal(true)}
          variant="secondary"
          mb={4}
          width={1}
          type="button"
        >
          What&apos;s the difference between cleans?
        </Button>

        <LinkText
          textAlign="center"
          px={2}
          mb={4}
          onClick={() => toggleMoveOutModal(true)}
        >
          Moving? Book a move-out service
        </LinkText>
      </MobileFlexWrapper>

      <HSvsDCModal show={show} dismiss={() => toggleModal(false)} />
      <MoveOutModal
        show={showMoveOut}
        onDismiss={() => toggleMoveOutModal(false)}
        onSubmit={handleBookMoveOut}
      />
    </MobileContainer>
  );
}

ServiceTypeSingle.propTypes = {
  selectedServiceType: PropTypes.string,
  serviceTypeData: PropTypes.object,
  setServiceType: PropTypes.func,
  initMoveOutBooking: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  propertyInfo: PropTypes.object
};

const mapStatesToProps = state => ({
  selectedServiceType: BookingSelectors.selectServiceType(state),
  serviceTypeData: AppSelectors.selectServiceTypeData(state),
  propertyInfo: AppSelectors.selectPropertyInfoOf(
    state,
    BookingSelectors.selectCurrentProperty(state)
  )
});

const mapDispatchToProps = dispatch => ({
  setServiceType: serviceType =>
    dispatch(BookingActions.setBookingServiceType(serviceType)),
  initMoveOutBooking: () => dispatch(BookingActions.initMoveOutBooking())
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(ServiceTypeSingle);
